const icon = require('vue-svgicon');
icon.register({
    'question': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M16.158 0c-4.997 0-8.585 2.921-9.362 7.621a.8.8 0 00.126.611c.12.168.309.279.529.314l1.734.288c.482.075.825-.184.902-.62.683-3.302 2.821-5.121 6.02-5.121 3.467 0 5.708 2.005 5.708 5.108 0 1.83-.421 3.079-3.04 6.082l-2.797 3.49c-1.271 1.528-1.699 2.761-1.699 4.884v1.866c0 .452.341.78.811.78h1.782c.47 0 .811-.328.811-.78v-1.675c0-1.726.204-2.462 1.564-4.026l2.791-3.53c2.35-2.66 3.182-4.516 3.182-7.093C25.22 3.372 21.494 0 16.158 0zM17.033 28.113h-2.008c-.407 0-.703.286-.703.679v2.529c0 .394.296.679.703.679h2.008c.408 0 .703-.286.703-.679v-2.529c0-.394-.296-.679-.703-.679z"/>`,
    },
});
